import React, { createContext, useContext, useState, useEffect } from 'react';
import config from '../config';

const StatsContext = createContext();

export const useStats = () => {
  const context = useContext(StatsContext);
  if (!context) {
    throw new Error('useStats должен использоваться внутри StatsProvider');
  }
  return context;
};

export const StatsProvider = ({ children }) => {
  const [approvedCarsCount, setApprovedCarsCount] = useState(0);
  const [totalViews, setTotalViews] = useState(0);
  const [loading, setLoading] = useState(true);

  const fetchStats = async () => {
    try {
      const response = await fetch(`${config.API_URL}/api/stats/approved-cars-count`);
      if (response.ok) {
        const data = await response.json();
        setApprovedCarsCount(data.count || 0);
        setTotalViews(data.totalViews || 0);
      } else {
        console.error('Ошибка ответа:', response.status, response.statusText);
      }
    } catch (error) {
      console.error('Ошибка при получении статистики:', error);
    } finally {
      setLoading(false);
    }
  };

  const refreshStats = () => {
    fetchStats();
  };

  useEffect(() => {
    fetchStats();
  }, []);

  const value = {
    approvedCarsCount,
    totalViews,
    loading,
    refreshStats
  };

  return (
    <StatsContext.Provider value={value}>
      {children}
    </StatsContext.Provider>
  );
};
